"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

var _clsx3 = _interopRequireDefault(require("clsx"));

var _PayUIcons = _interopRequireDefault(require("../PayUIcons"));

var _styles2 = _interopRequireDefault(require("./styles"));

var _excluded = ["className", "children", "onClick", "status", "buttonType", "disabled", "classes", "startIcon"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function InfoButton(_ref) {
  var _clsx;

  var classNameProp = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      status = _ref.status,
      buttonType = _ref.buttonType,
      disabled = _ref.disabled,
      classes = _ref.classes,
      startIcon = _ref.startIcon,
      rest = _objectWithoutProperties(_ref, _excluded);

  var btnClassName = (0, _clsx3["default"])((_clsx = {}, _defineProperty(_clsx, classes.info, true), _defineProperty(_clsx, classes.labelSuccess, status === "SUCCESS"), _defineProperty(_clsx, classes.labelDanger, status === "DANGER"), _defineProperty(_clsx, classes.labelWarning, status === "WARNING"), _defineProperty(_clsx, classes.labelInfo, status === "INFO"), _defineProperty(_clsx, classes.labelDebug, status === "DEBUG"), _defineProperty(_clsx, classes.labelDisabled, disabled), _defineProperty(_clsx, classNameProp, classNameProp), _clsx));
  var startIconClassName = (0, _clsx3["default"])(_defineProperty({}, classes.startIcon, true));
  var startIconColor = status === "SUCCESS" ? 'success' : status === "DANGER" ? 'danger' : status === "WARNING" ? 'warning' : status === "INFO" ? 'info' : status === "DEBUG" ? 'default' : 'white';
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    variant: "text",
    onClick: onClick,
    className: (0, _clsx3["default"])(btnClassName, "infobtn"),
    type: buttonType
  }, rest), startIcon && startIcon.type && /*#__PURE__*/_react["default"].createElement(_PayUIcons["default"], {
    type: startIcon.type,
    size: startIcon.size,
    color: startIconColor,
    className: startIconClassName
  }), children);
}

InfoButton.defaultProps = {
  className: "",
  children: "",
  status: "INFO",
  onClick: function onClick() {
    return 0;
  },
  buttonType: "button",
  disabled: false,
  startIcon: {
    type: null,
    size: '12px'
  }
};
InfoButton.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  status: _propTypes["default"].oneOf(["SUCCESS", "DANGER", "WARNING", "INFO", "DEBUG", "DISABLED"]),
  buttonType: _propTypes["default"].oneOf(["button", "submit"]),
  disabled: _propTypes["default"].bool,
  startIcon: _propTypes["default"].object
};

var _default = (0, _styles.withStyles)(_styles2["default"])(InfoButton);

exports["default"] = _default;